<template>
  <div style="width:100%;max-width:1200px;">
    <Player :video="video.src" @timeupdate="time => this.time = time">
      <Overlay slot="overlay" :tags="video.tags" :time="time" />
    </Player>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import Player from './core'
  import Overlay from './overlay'

  export default {
    name: 'player',
    data: () => ({
      time: 0
    }),
    computed: {
      ...mapState(['video'])
    },
    components: {
      Player,
      Overlay
    }
  }

</script>
